'use client';

import { useQuery } from '@tanstack/react-query';
import { useAuth } from 'react-oidc-context';

import { getNotificationsCount } from '../../apis/notification/menu';
import { NOTIFICATION_COUNT_KEY, NOTIFICATION_INTERVAL } from '../../constants/notification-manager';

export const useNotificationCount = () => {
  const { isAuthenticated, user: session } = useAuth();

  return useQuery(
    NOTIFICATION_COUNT_KEY,
    async () => await getNotificationsCount(session?.access_token as string),
    {
      keepPreviousData: true,
      refetchInterval: NOTIFICATION_INTERVAL,
      enabled: isAuthenticated,
    },
  );
};
